// Recovered compiled webpack factory 16815. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { G: () => n });
  let n = (t) => (e) => 1 - t(1 - e);
}
